import React from "react";
import './style.css';
import styled from "styled-components";
import DiamondImage from "./shape-image";

const Card = styled.div`
  display: flex;
  padding: 15px;
  align-items: center;
  margin-top: 15px;
  border-radius: 15px;
  background-color: #F8E6F7;
  flex-direction: column;
`;

const HighlightCard = styled.div`
  display: flex;
  padding: 24px;
  align-items: center;
  margin-top: 15px;
  border-radius: 15px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  flex-direction: column;
  color: #fff;
  box-shadow: 0 4px 20px rgba(102, 126, 234, 0.4);
`;

export const Home = () => {
    return (
        <>
            <div className="container" style={{marginBottom: 15}}>
                <div className="row" style={{paddingTop: 20}}>
                    <div className="col-12 d-flex align-items-center">
                        <a href="https://madeyuai.com/" target="_blank" rel="noopener noreferrer" className="d-flex align-items-center" style={{textDecoration: 'none'}}>
                            <img src="madeyu-logo.png" height="64px" width="64px" className="img-fluid rounded-circle"/>
                            <h2 style={{marginLeft: 12, marginBottom: 0, color: '#333'}}>MadeYu - AI Art & Video</h2>
                        </a>
                    </div>
                </div>
                <div className="row">
                    <div className="d-flex justify-content-center" style={{marginTop: 20}}>
                        <a href="https://madeyuai.com/" target="_blank" rel="noopener noreferrer"
                           style={{
                               display: 'inline-block',
                               padding: '16px 48px',
                               fontSize: '20px',
                               fontWeight: 'bold',
                               color: '#fff',
                               background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                               borderRadius: '50px',
                               textDecoration: 'none',
                               boxShadow: '0 4px 15px rgba(102, 126, 234, 0.4)',
                           }}>
                            Try MadeYu Web App
                        </a>
                    </div>
                    <div className="d-flex justify-content-center" style={{marginTop: 24}}>
                        <span style={{fontSize: '14px', color: '#888'}}>Also available on mobile:</span>
                    </div>
                    <div className="d-flex justify-content-center align-items-center" style={{marginTop: 8, gap: '12px', flexWrap: 'wrap'}}>
                        <a href="https://pse.is/568vgb" target="_blank" rel="noopener noreferrer">
                            <img src="app-download-icon.svg" alt="MadeYu - AI Art & Video" className="img-fluid" width="200px"/>
                        </a>
                        <a href="https://play.google.com/store/apps/details?id=com.madeyuai.madewatoo" target="_blank" rel="noopener noreferrer">
                            <img src="google-play-download-icon.svg" alt="MadeYu - AI Art & Video" className="img-fluid" width="230px"/>
                        </a>
                    </div>
                    {/*<div style={{height: 15, borderRadius: 15, background: "#DEC0C0", marginTop: 15}} />*/}

                    {/*<div className="col-lg-12 col-md-12 col-sm-12 col-12">*/}
                    {/*    <h5 className="d-flex align-items-center" style={{paddingTop: 50, paddingBottom: 50}}>*/}
                    {/*        MadeYu is an AI-powered creative platform that lets you generate stunning images and videos from text prompts or reference images. Choose from a variety of real-world and anime styles, and bring your ideas to life with AI storytelling video.*/}
                    {/*    </h5>*/}
                    {/*</div>*/}

                    <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                        <HighlightCard>
                            <h1 className="d-flex" style={{color: '#fff'}}>Image to Video</h1>
                            <h5 className="d-flex align-items-center" style={{color: 'rgba(255,255,255,0.9)', textAlign: 'center'}}>
                                Transform your still images into captivating AI-generated videos. Upload an image and let MadeYu bring it to life with motion and storytelling. Create dynamic video content from a single image — perfect for social media, presentations, and creative projects.
                            </h5>
                            <a href="https://madeyuai.com/" target="_blank" rel="noopener noreferrer"
                               style={{
                                   display: 'inline-block',
                                   marginTop: 12,
                                   padding: '12px 36px',
                                   fontSize: '16px',
                                   fontWeight: 'bold',
                                   color: '#764ba2',
                                   background: '#fff',
                                   borderRadius: '50px',
                                   textDecoration: 'none',
                               }}>
                                Try Image to Video
                            </a>
                        </HighlightCard>
                    </div>

                    <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                        <Card>
                            <h1 className="d-flex">Text to Image</h1>
                            <div className="d-flex">
                                <DiamondImage size={"150px"} src="image1.png"/>
                                <h5 className="d-flex align-items-center">
                                    To use text prompts in MadeYu, simply type a description of what you want to generate. The AI will interpret your prompt and create an image based on your input. Be as detailed or creative as you like—the more specific your prompt, the more tailored the output will be.
                                </h5>
                            </div>
                        </Card>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                        <Card>
                            <h1 className="d-flex">Image to Image</h1>
                            <div className="d-flex">
                                <h5 className="d-flex align-items-center" >
                                    To use the image-to-image feature in MadeYu, upload an image you want to transform. The AI will analyze it and generate a new version based on your input. You can add text prompts for more specific results or let the AI creatively reimagine the image.
                                </h5>
                                <DiamondImage size={"150px"} src="image2.png"/>
                            </div>
                        </Card>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                        <Card>
                            <h1 className="d-flex">Inpaint</h1>
                            <div className="d-flex">
                                <DiamondImage size={"150px"} src="image3.png"/>
                                <h5 className="d-flex align-items-center">
                                    To use the inpaint feature in MadeYu, upload an image and select the area you want to edit. The AI will fill in the selected area based on your description, seamlessly blending it with the rest of the image.
                                </h5>
                            </div>
                        </Card>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                        <Card>
                            <h1 className="d-flex">Details Control</h1>
                            <div className="d-flex">
                                <h5 className="d-flex align-items-center" >
                                    To use the detail control feature in MadeYu, you can adjust specifics like facial expression, body expression, and image ratio. This allows you to fine-tune the details and get exactly the result you want.
                                </h5>
                                <DiamondImage size={"150px"} src="image4.png"/>
                            </div>
                        </Card>
                    </div>
                </div>
            </div>
        </>
    )
}
